import { jsx as _jsx } from "react/jsx-runtime";
import React, { lazy, Suspense } from 'react';
import jQuery from 'jquery';
import { createRoot } from 'react-dom/client';
const BoughtTogether = lazy(() => import(/* webpackChunkName: 'BoughtTogether', webpackPrefetch: true */ './boughtTogether'));
const ShopifyBoughtTogether = lazy(() => import(/* webpackChunkName: 'ShopifyBoughtTogether', webpackPrefetch: true */ './shopifyBoughtTogether'));
export default function LoadBoughtTogether(el) {
    var _a, _b;
    const intersectionElement = document.createElement('div');
    jQuery(intersectionElement).insertBefore(el);
    const jElement = jQuery(el);
    let data = jElement.data();
    const intersectionRootElement = createRoot(intersectionElement);
    const rootElement = createRoot(el);
    const rootRender = (children) => {
        const elHeight = el.clientHeight;
        el.style.height = `${elHeight}px`;
        rootElement.render(children);
        setTimeout(() => {
            el.style.height = '';
        }, 1500);
    };
    const isShopify = !((_b = (_a = globalThis === null || globalThis === void 0 ? void 0 : globalThis.algoliaShopify) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.app_id);
    if (!isShopify) {
        data = Object.assign(Object.assign({}, data), { metafieldIds: data.metafieldIds
                .split(',')
                .map((id) => (id.includes('-') ? id.split('-')[1] : id))
                .join(','), ids: data.ids
                .split(',')
                .map((id) => (id.includes('-') ? id.split('-')[1] : id))
                .join(',') });
    }
    intersectionRootElement.render(_jsx(Suspense, Object.assign({ fallback: _jsx("div", {}) }, { children: isShopify ? (_jsx(ShopifyBoughtTogether, { data: data, renderedElement: el, rootRender: rootRender })) : (_jsx(BoughtTogether, { data: data, renderedElement: el, rootRender: rootRender })) })));
}
